import {InputBase, Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXResourceAssociationsPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Intelligence References</Typography>
            </Stack>

            <Stack direction="row" spacing={1} padding={1} alignItems="center" justifyContent="center">
                <InputBase placeholder="Filter" sx={appStyles.panelFilterInput} />
                <Typography sx={appStyles.panelFilterCount}>Showing 0 of 0</Typography>
            </Stack>
        </Stack>
    );
}

export default UXResourceAssociationsPanel;
